import { Skeleton, Typography } from '@frontend-workspace/react-shared-lib';

export function SalesOfferSkeleton() {
  return (<>
    <Typography
      variant="h2"
      component="div"
      className="pt-4 mb-5"
      sx={{ flexGrow: 1 }}>
      <Skeleton animation="wave" width={150} height={40} />
    </Typography>

    <Skeleton variant="rectangular" animation="wave" width='100%' height={700} />

    <div className='d-flex justify-content-end'>
      <Skeleton className='me-3' animation="wave" width={150} height={50} />
      <Skeleton className='me-3' animation="wave" width={150} height={50} />
      <Skeleton animation="wave" width={150} height={50} />
    </div>
  </>
  );
}

export default SalesOfferSkeleton;
